import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopOverComponent } from '@app/shared/components/pop-over/pop-over.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'pcs-component-library';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    IconModule,
    PortalModule,
    OverlayModule
  ],
  declarations: [
    PopOverComponent
  ],
  exports: [
    PopOverComponent,
    PortalModule
  ]
})
export class PopOverModule {
}
